const API_URL = import.meta.env.VITE_GETSIGN_API_URL;

export const isEditorOnboarded = async () => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(`${API_URL}/user/is-editor-onboarded`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });
  const response = await res.json();
  return response;
};

export const setEditorOnboarded = async () => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(`${API_URL}/user/editor-onboarded`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });
  const response = await res.json();
  return response;
};

export const setEditorInitialLoadStatus = async () => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(`${API_URL}/user/set-is-initial-load`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
  });
  const response = await res.json();
  return response;
};
